import React from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { AppConditionRatingAutocomplete } from "@components/Autocomplete"


export default function ReportRatingAlertField() {
	const {
		conditionsRating,
		setConditionsRatingInfo,
		error
	} = useReportFormInfo(reportFormData.peek().conditionsRating || [], "conditionsRating", object({ conditionsRating: array().nullable() }))

	return <AppConditionRatingAutocomplete
		multiple
		value={conditionsRating}
		onChange={e => setConditionsRatingInfo(e.target.value)}
		error={error}
	/>
}